import { render, staticRenderFns } from "./ProductInfoBuy.vue?vue&type=template&id=7ad33354"
import script from "./ProductInfoBuy.vue?vue&type=script&lang=ts"
export * from "./ProductInfoBuy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad33354')) {
      api.createRecord('7ad33354', component.options)
    } else {
      api.reload('7ad33354', component.options)
    }
    module.hot.accept("./ProductInfoBuy.vue?vue&type=template&id=7ad33354", function () {
      api.rerender('7ad33354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoBuy.vue"
export default component.exports